const createRequestState = () => ({
  status: "idle",
  data: null,
  error: null,
  promise: null,
});

const deptCityState = createRequestState();
const searchGroupStateMap = new Map();

const showRequestError = (message) => {
  if (!message || typeof window.ShowDialog !== "function") {
    return;
  }

  window.ShowDialog("error", "", message);
};

const createRequestError = (message, extra = {}) => {
  const error = new Error(message || "Search engine request failed.");
  error.isHandled = true;
  Object.assign(error, extra);
  return error;
};

const getHomePageBaseUrl = () => {
  const host = location.hostname;

  if (
    host.includes("localhost") ||
    host.includes("ibwt.com.tw") ||
    host.includes("bbctour.com.tw")
  ) {
    return "https://ncapi.ibwt.com.tw/HomePage";
  }

  return "https://ncapi.bwt.com.tw/HomePage";
};

const fetchJson = async (url, requestMeta = {}) => {
  let response;

  try {
    response = await fetch(url);
  } catch (error) {
    const requestError = createRequestError(
      error?.message || `${requestMeta.type || "Request"} failed.`,
      requestMeta,
    );
    showRequestError(requestError.message);
    throw requestError;
  }

  if (!response.ok) {
    const requestError = createRequestError(`HTTP ${response.status}`, {
      ...requestMeta,
      status: response.status,
    });
    showRequestError(requestError.message);
    throw requestError;
  }

  return response.json();
};

const resolveSharedState = (state, loader) => {
  if (state.status === "resolved") {
    return Promise.resolve(state.data);
  }

  if (state.status === "loading" && state.promise) {
    return state.promise;
  }

  state.status = "loading";
  state.error = null;
  state.promise = loader()
    .then((data) => {
      state.status = "resolved";
      state.data = data;
      return data;
    })
    .catch((error) => {
      state.status = "rejected";
      state.error = error;
      state.promise = null;
      throw error;
    });

  return state.promise;
};

export const loadDeptCityList = () =>
  resolveSharedState(deptCityState, () =>
    fetchJson(`${getHomePageBaseUrl()}/Present/GetDeptCityList`, {
      type: "GetDeptCityList",
    }),
  );

export const loadSearchGroupList = (webDesignUse = "") => {
  const cacheKey = webDesignUse || "__default__";

  if (!searchGroupStateMap.has(cacheKey)) {
    searchGroupStateMap.set(cacheKey, createRequestState());
  }

  return resolveSharedState(searchGroupStateMap.get(cacheKey), () =>
    fetchJson(`${getHomePageBaseUrl()}/Present/GetSearchList?type=group`, {
      type: "GetSearchList",
      webDesignUse,
    }),
  );
};

export const resetSearchEngineBaseService = () => {
  deptCityState.status = "idle";
  deptCityState.data = null;
  deptCityState.error = null;
  deptCityState.promise = null;
  searchGroupStateMap.clear();
};
